<template>
    <div class="auth-wrapper">
        <div class="auth-inner py-1 px-1">
            <b-card>
                <b-card-text>
                    <b-link class="brand-logo">
                        <h2 class="brand-text" style="margin:auto 0">
                            <span style="font-size:xx-large">
                                HyperBilling
                            </span>
                        </h2>
                    </b-link>
                </b-card-text>
                <b-card-text>
                    <LoginFormBase
                        v-if="!requiredOtp && isCommonLogin"
                        @auth:otp="nextAuthStepOtp"
                    />
                    <LoginFormOtp
                        v-else-if="requiredOtp"
                        @auth:base="prevAuthStepBase"
                    />
                    <LoginFormPops
                        v-if="!requiredOtp && isPopsLogin"
                    />
                </b-card-text>
                <MobileFooter v-if="isMobile"/>
            </b-card>
        </div>
    </div>
</template>
<script>
import { computed, ref } from '@vue/composition-api'
import isMobileLib from 'is-mobile'
import useEnvString from '@/composables/useEnvString'
import MobileFooter from '@/views/Shared/MobileFooter'

import LoginFormBase from './LoginFormBase'
import LoginFormOtp from './LoginFormOtp'
import LoginFormPops from './LoginFormPops'
export default {
    components: {
        LoginFormBase,
        LoginFormOtp,
        LoginFormPops,
        MobileFooter
    },
    setup () {
        const {
            VUE_APP_COMMON_LOGIN,
            VUE_APP_POPS_LOGIN
        } = useEnvString()
        const requiredOtp = ref(false)
        const isMobile = computed(() => isMobileLib())
        const isCommonLogin = computed(() => VUE_APP_COMMON_LOGIN === 'TRUE')
        const isPopsLogin = computed(() => VUE_APP_POPS_LOGIN === 'TRUE')
        const prevAuthStepBase = () => {
            requiredOtp.value = false
        }
        const nextAuthStepOtp = () => {
            requiredOtp.value = true
        }

        return {
            isCommonLogin,
            isPopsLogin,
            isMobile,
            requiredOtp,
            prevAuthStepBase,
            nextAuthStepOtp
        }
    }
}

</script>
<style lang="scss" scoped>
/** LOGIN FORM */
.auth-wrapper {
    position: relative;
    max-width: 525px;
    margin: 0 auto;
    .auth-inner {
        margin: auto;
    }
}
</style>
